import React from 'react'
import { toast } from 'react-toastify'

const VerifyDomainPopup = ({ publishScript, onClose, onVerify, siteurl }) => {
  return (
    <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
      <div className='bg-white shadow-lg w-full max-w-[900px] mx-auto my-[30px] rounded-[24px] border border-gray-200 overflow-y-auto min-h-[40%] max-h-[90%] scrollbar-hide'>
        {/* Header */}
        <div className='flex justify-between items-center px-7 py-4 border-b mb-6'>
          <h2 className='text-xl font-bold text-gray-800'>
            Verify domain ownership
          </h2>
          <button
            className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] text-[14px] sm:text-[18px] cursor-pointer'
            onClick={onClose}
          >
            <svg
              width='30'
              height='30'
              viewBox='0 0 30 30'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.1 7.77a1 1 0 0 0-1.33 1.33L13.67 15l-5.9 5.9a1 1 0 1 0 1.33 1.33L15 16.33l5.9 5.9a1 1 0 0 0 1.33-1.33L16.33 15l5.9-5.9a1 1 0 1 0-1.33-1.33L15 13.67 9.1 7.77Z'
                fill='#373737'
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className='px-4 py-2'>
          <ol className='list-decimal pl-5 text-sm text-gray-700 space-y-4'>
            <li>
              <p className='mb-2'>
                Copy the code below and paste it before the end of the{' '}
                <code>&lt;/body&gt;</code> section on your website ({siteurl}).
              </p>
              <div className='relative'>
                <pre className='bg-gray-100 p-4 rounded-md text-xs overflow-x-auto border border-gray-300 font-mono whitespace-pre-wrap'>
                  <code>{publishScript}</code>
                </pre>
                <button
                  onClick={() => {
                    navigator.clipboard
                      .writeText(publishScript)
                      .then(() => {
                        toast.success('Script copied to clipboard!', {
                          position: 'bottom-center'
                        })
                      })
                      .catch(() => {
                        toast.error('Failed to copy script')
                      })
                  }}
                  className='absolute top-2 right-2 bg-white hover:bg-gray-200 border border-gray-300 p-1 rounded shadow text-xs'
                  title='Copy to clipboard'
                >
                  📋
                </button>
              </div>
              <p className='text-xs text-gray-500 mt-2'>
                Note: This script both verifies your domain and adds the chatbot
                to your website automatically.
              </p>
            </li>
            <li>
              Press <b>Start Verification</b> below to verify your domain
              ownership.
            </li>
            <li>
              Please wait for verification to complete before closing this tab.
            </li>
          </ol>

          <p className='text-sm text-gray-700 pl-5 mt-3'>or</p>
          <p className='text-sm text-gray-700 pl-5'>
            Need help verifying ownership? No worries — we're happy to help!
            Reach out at <strong>support@magbot.ai</strong>
          </p>
        </div>

        {/* Footer */}
        <div className='flex justify-end mt-5 p-4 border-t gap-3'>
          <button
            className='py-2 px-10 text-sm rounded-[19px] bg-gray-800 text-white'
            onClick={() => {
              onClose()
              window.dispatchEvent(new CustomEvent('go-home'))
            }}
          >
            Verify Later
          </button>
          <button
            className='bg-[#7C50DD] text-white py-2 px-10 text-sm rounded-[19px]'
            onClick={onVerify}
          >
            Start Verification
          </button>
        </div>
      </div>
    </div>
  )
}

export default VerifyDomainPopup
